if (!customElements.get('pr-sale-countdown')) customElements.define('pr-sale-countdown', class extends HTMLElement {
 connectedCallback() {
  const deadline = this.dataset.end;
  let end = /T.*(Z|[+-]\d{2}:\d{2})$/.test(deadline) ? Date.parse(deadline) : NaN;
  const daily = this.dataset.daily === 'true';
  const nextMidnight = () => {
   const format = new Intl.DateTimeFormat('en-US', { timeZone: this.dataset.zone || 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
   const parts = date => Object.fromEntries(format.formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
   const current = parts(new Date());
   const target = Date.UTC(current.year, current.month - 1, current.day + 1);
   let candidate = target;
   for (let i = 0; i < 4; i++) {
    const p = parts(new Date(candidate));
    candidate += target - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
   }
   return candidate;
  };
  if (daily) { try { end = nextMidnight(); } catch { end = NaN; } }
  const active = this.querySelector('[data-clock-active]');
  const idle = this.querySelector('[data-clock-idle]');
  const tick = () => {
   if (daily && Date.now() >= end) end = nextMidnight();
   const total = Math.max(0, Math.floor((end - Date.now()) / 1000));
   const running = Number.isFinite(end) && total > 0;
   active.hidden = !running; idle.hidden = running;
   if (!running) { clearInterval(this.timer); return; }
   const values = { hours: Math.floor(total / 3600), minutes: Math.floor(total / 60) % 60, seconds: total % 60 };
   Object.entries(values).forEach(([key, value]) => this.querySelector(`[data-${key}]`).textContent = String(value).padStart(2, '0'));
  };
  this.timer = setInterval(tick, 1000); tick();
 }
 disconnectedCallback() { clearInterval(this.timer); }
});
